/* file description */

export const skuList = [{
  value: true,
  label: 'sku',
}, {
  value: false,
  label: 'spu',
}, {
  value: null,
  label: '全部',
}];

export const dataStatus = [{
  value: '01',
  label: '未生效',
}, {
  value: '02',
  label: '已生效',
}, {
  value: '03',
  label: '已注销',
}, {
  value: '04',
  label: '已合并',
}, {
  value: '',
  label: '全部',
}];
